import { combineReducers } from "redux";
import stateDirectoryReducer from "./state.directory.reducer";

const directoryReducer = combineReducers({
	states: stateDirectoryReducer,
});

export default directoryReducer;
